import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import OrderStatusClass from '../../../types/OrderStatusClass';
import Icon from '../../common/Icon';

const labels = {
  [OrderStatusClass.PROCESSING]: (
    <FormattedMessage id="orderStatus.processing" defaultMessage="Processing" />
  ),
  [OrderStatusClass.READY]: (
    <FormattedMessage id="orderStatus.ready" defaultMessage="Ready" />
  ),
  [OrderStatusClass.CANCELED]: (
    <FormattedMessage id="orderStatus.canceled" defaultMessage="Canceled" />
  ),
  [OrderStatusClass.PENDING]: (
    <FormattedMessage id="orderStatus.pending" defaultMessage="Pending" />
  ),
  [OrderStatusClass.ACTIVE]: (
    <FormattedMessage id="orderStatus.active" defaultMessage="Active" />
  ),
  [OrderStatusClass.DEACTIVATED]: (
    <FormattedMessage
      id="orderStatus.deactivated"
      defaultMessage="Deactivated"
    />
  ),
  [OrderStatusClass.ON_HOLD]: (
    <FormattedMessage id="orderStatus.onHold" defaultMessage="On hold" />
  ),
};

class OrderStatusLabel extends Component {
  getModifierClassName = () => {
    let modifier;

    switch (this.props.status) {
      case OrderStatusClass.CANCELED:
      case OrderStatusClass.DEACTIVATED:
        modifier = 'canceled';
        break;
      case OrderStatusClass.PENDING:
      case OrderStatusClass.PROCESSING:
      case OrderStatusClass.ON_HOLD:
        modifier = 'processing';
        break;
      case OrderStatusClass.READY:
      case OrderStatusClass.ACTIVE:
        modifier = 'ready';
        break;
      default:
        return null;
    }

    return `OrderStatusLabel__status--${modifier}`;
  };

  render() {
    const { status } = this.props;
    const statusMessage = labels[status];

    return statusMessage ? (
      <span
        className={classNames(
          'OrderStatusLabel',
          this.getModifierClassName(this.props.status)
        )}
      >
        <Icon className="OrderStatusLabel__status-icon" name="circle" />
        {statusMessage}
      </span>
    ) : null;
  }
}

OrderStatusLabel.propTypes = {
  status: PropTypes.oneOf(Object.values(OrderStatusClass)),
};

export default OrderStatusLabel;
